import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const AnimatedElement = ({ children, delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay * 1000); // Délai en secondes

    return () => clearTimeout(timer); // Nettoyage du timer
  }, [delay]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }} // Commence en bas avec opacité 0
      animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Animation après le délai
      transition={{ duration: 0.8, ease: "easeOut" }} // Durée de l'animation
    >
      {children}
    </motion.div>
  );
};

export default AnimatedElement;
